// extracted by mini-css-extract-plugin
module.exports = {"only_mobile":"_93444fe79c--only_mobile--kAzh0","only_tablet":"_93444fe79c--only_tablet--E_4Pi","only_desktop":"_93444fe79c--only_desktop--2uaVm"};